import React from 'react'
import Layout from '../layouts/layout'
import Wrapper from '../layouts/wrapper'
import { strings } from '../components/kiosk-item-prices/kiosk-item-prices-content'
import KioskItemPricesTable from '../components/kiosk-item-prices/kiosk-item-prices-table'
import withPermissionCheck from '../../core/access-control/with-permission-check'
import { Permission } from '../../core/auth0'

const KioskItemPricesScreen: React.FC = () => {
  return (
    <Layout location="kiosk_item_prices">
      <Wrapper title={strings.title}>
        <KioskItemPricesTable />
      </Wrapper>
    </Layout>
  )
}

export default withPermissionCheck(KioskItemPricesScreen, {
  requiredPermission: Permission.KIOSK_PRICE_READ,
  redirectTo: '/404',
})
